var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 3.94446C10.8408 3.94446 9.89413 4.85503 9.8363 6.00001H14.164C14.1062 4.85503 13.1595 3.94446 12.0002 3.94446ZM12.0002 2.94446C10.2885 2.94446 8.89394 4.30257 8.83541 6.00001H4.5C4.22386 6.00001 4 6.22387 4 6.50001C4 6.77616 4.22386 7.00001 4.5 7.00001H5.54891L6.90686 19.643C6.98871 20.405 7.63186 20.9828 8.39828 20.9828H15.6016C16.368 20.9828 17.0112 20.405 17.093 19.643L18.451 7.00001H19.5C19.7761 7.00001 20 6.77616 20 6.50001C20 6.22387 19.7761 6.00001 19.5 6.00001H15.1649C15.1064 4.30257 13.7119 2.94446 12.0002 2.94446ZM7.90114 19.5362L6.55652 7.01726H17.4434L16.0987 19.5362C16.0715 19.7902 15.8571 19.9828 15.6016 19.9828H8.39828C8.14281 19.9828 7.92843 19.7902 7.90114 19.5362ZM10.9999 10.1207C10.9999 9.84456 10.7761 9.62071 10.4999 9.62071C10.2238 9.62071 9.99994 9.84456 9.99994 10.1207L9.99994 16.3621C9.99994 16.6382 10.2238 16.8621 10.4999 16.8621C10.7761 16.8621 10.9999 16.6382 10.9999 16.3621L10.9999 10.1207ZM13.4999 9.62071C13.7761 9.62071 13.9999 9.84456 13.9999 10.1207V16.3621C13.9999 16.6382 13.7761 16.8621 13.4999 16.8621C13.2238 16.8621 12.9999 16.6382 12.9999 16.3621V10.1207C12.9999 9.84456 13.2238 9.62071 13.4999 9.62071Z",
    fill: "#E51717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bdc8855d4e4cc5cf910d921f76f9dd3d.svg";
export { ForwardRef as ReactComponent };